module.exports = __webpack_public_path__ + "484aaa3497446c4d9bced67c896f7eeb.svg";